<script>
  import { Doughnut } from 'vue-chartjs'
  import chartRendererMixin from '@/components/elements/charts/chartRendererMixin'

  export default {
    extends: Doughnut,
    mixins: [chartRendererMixin]
  }
</script>



// WEBPACK FOOTER //
// DoughnutChart.vue?63496ed5